import './navbar.less';

angular.module('tromanWeb').controller('NavbarController', ['authenticationService', 'systemInfo', 'userProfile', function navController(authenticationService, systemInfo, userProfile) {

    var self = this;

    self.user = userProfile;

    self.isPolitikerEnabled = systemInfo.IsPolitikerEnabled;

    self.logout = function logout() {
        authenticationService.logout();
        location.href = "../";
    };

}]);
